// services/car.ts
import api from './api';
import { Car } from '../types/car';

export const carService = {
    async getAllCars(): Promise<Car[]> {
        try {
            const response = await api.get('/cars/list');
            return response.data.cars;
        } catch (error) {
            console.error('車両データの取得に失敗:', error);
            throw error;
        }
    },

    async getCarById(id: number): Promise<Car> {
        try {
            const response = await api.get(`/cars/${id}`);
            return response.data;
        } catch (error) {
            console.error('車両データの取得に失敗:', error);
            throw error;
        }
    }
};